import {Breadcrumb, Button, Card, Col, Row} from "antd";
import {ReactNode} from "react";
import {BreadcrumbItemProps} from "antd/lib/breadcrumb/BreadcrumbItem";
import {ArrowLeftOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";

export function GlobalCard({ children, breadcrumb, showBack }: { children: ReactNode, breadcrumb?: Array<BreadcrumbItemProps>, showBack?: boolean }) {
  const navigate = useNavigate();

  return (
    <Row>
      <Col span={24} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {showBack && (
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            style={{ padding: '0 4px' }}
          />
        )}
        <Breadcrumb>
          {
            breadcrumb?.map((breard, index) => (
              <Breadcrumb.Item key={index}>{ breard.children }</Breadcrumb.Item>
            ))
          }
        </Breadcrumb>
      </Col>
      <Col span={24} className="mt-1">
        <Card className="border-radius shadow-sm p-1">
          { children }
        </Card>
      </Col>
    </Row>
  );
}
